/**
 * Caches that belong to whoever is signed in.
 *
 * Pages render these instantly on mount, before any request goes out, so a
 * leftover entry is painted as if it were the current user's — someone signing
 * in after a colleague on the same device would see their rankings, standings
 * and stats for a frame. The entries are keyed by resource id, not by account,
 * so they have to be purged whenever the account changes.
 *
 * Device preferences (bt_install_dismissed_at, bt_pwa_tracked, feedback flags)
 * are deliberately not listed: they describe the browser, not the person.
 */
const USER_SCOPED_PREFIXES = [
  'bt_ranking_detail_',
  'bt_ranking_round_',
  'bt_rankings_list',
  'bt_competitions_list',
  'bt_my_stats',
  'bt_awaiting_payment_',
  'bt_signup_intent',
];

function purge(storage: Storage): void {
  try {
    const doomed = Object.keys(storage).filter((key) =>
      USER_SCOPED_PREFIXES.some((prefix) => key.startsWith(prefix))
    );
    for (const key of doomed) storage.removeItem(key);
  } catch {
    // Storage unavailable (private mode, quota) — nothing cached to leak.
  }
}

export function clearUserScopedCaches(): void {
  purge(localStorage);
  purge(sessionStorage);
}
